<template>
  <div>
    <BlockTitle
      :title="t('Отзывы врачей', options)"
      class="mb-8"
    />
    <CoreSwiper>
      <template #slides="{ slideAttrs, swiperInstance }">
        <div
          v-for="doctorReview in doctorReviews"
          :key="doctorReview.id"
          class="border rounded-sm text-center py-6"
          v-bind="slideAttrs"
        >
          <DoctorReviewSlide
            :doctor-review="doctorReview"
            :swiper-instance="swiperInstance"
          />
        </div>
      </template>
    </CoreSwiper>
  </div>
</template>

<script setup lang="ts">
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import DoctorReviewSlide from 'src/components/pages/info/pressa/components/mobile/DoctorReviewSlide.vue'
import I18NextVue from 'i18next'
import { DoctorReview } from 'src/components/pages/info/pressa/types'
import BlockTitle from 'src/components/pages/info/pressa/components/BlockTitle.vue'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  doctorReviews: DoctorReview[]
}>()
</script>

<style scoped lang="scss">
.swiper-slide,
.swiper-slide * {
  box-sizing: border-box;
}
</style>
